import debug from "debug";

const baseLogger = debug("rtc");
const loggers: { [key: string]: debug.Debugger } = {};

export const getLogger = (namespace: string) => {
	if (loggers[namespace]) {
		baseLogger(`Logger for namespace ${namespace} already exists`);
		return loggers[namespace];
	}

	baseLogger(`Creating logger for namespace ${namespace}`);
	loggers[namespace] = baseLogger.extend(namespace);
	return loggers[namespace];
};
